
<div class="container justify-content-center w-100" style="padding: 0px !important;" *ngIf="!loading">
	
	<div class="header-sep">
		<cas-text variant="headline2" (click)="ver()">{{tituloPaso2}} </cas-text>
	</div>
	<cas-text variant="body1" class="header-bajada">
		{{bajadaPaso2}}
	</cas-text>

  <div class="container w-100 px-3 py-3 pb-5 card" style="background-color: white; border-radius: 8px; margin-bottom: 50px;">

    <!-- Inicio. Form -->
    <form [formGroup]="formInfoHosp" class="flex-container wrap" style="border: none !important">


      <!-- Inicio. Motivo hospitalización / selector cuando es cirugía -->
      <div class="row w-100">

        <!-- Inicio. Motivo de hospitalización -->
        <div class="col-xl-6 col-lg-6 col-md-12 p-2">
          <mat-form-field class="custom-select-material w-100" floatLabel="always" [ngClass]="{'input-error-border': isMotivoError}" >
            <mat-select [placeholder]="labelMotivo" id="idmotivo1" formControlName="motivoDescrip"
            (selectionChange)="onChangeMotivo($event.value)"><!--  -->
              <mat-option *ngFor="let motivo of listaMotivos" [value]="motivo" [selected]="formInfoHosp.value.motivoDescrip">
                {{ motivo }}
              </mat-option>
            </mat-select>
            <mat-hint *ngIf="isMotivoError" class="error-text">
              Recuerda Ingresar el Motivo.
            </mat-hint>
          </mat-form-field>
        </div>
        <!-- Inicio. Motivo de hospitalización -->

        <!-- Inicio. Selector cuando motivo es cirugía -->
        <div class="col-xl-6 col-lg-6 col-md-12 p-2" *ngIf="(flagDeclaraAcc && selectedMotivo=='Cirugía')">
          <mat-form-field class="custom-select-material w-100" floatLabel="always"
            [ngClass]="{'input-error-border': isTraumaError}">
            <mat-select [placeholder]="labelTraumatologica" formControlName="cirugiaTraumatologica"
              (selectionChange)="onChangeTraumatologica($event.value, 'cirugiaTraumatologica')">
              <mat-option [value]="true" [selected]="formInfoHosp.value.cirugiaTraumatologica">Sí
              </mat-option>
              <mat-option [value]="false" [selected]="!formInfoHosp.value.cirugiaTraumatologica">No
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-hint *ngIf="(flagDeclaraAcc && selectedMotivo=='Cirugía') && isTraumaError"
            class="error-text">
            Selecciona una opción según tu tipo de cirugía.
          </mat-hint>
        </div>
        <!-- Fin. Selector cuando motivo es cirugía -->

      </div>
      <!-- Fin. Motivo hospitalización / selector cuando es cirugía -->


      <!-- Inicio. Declaración de accidente (trauma=Sí + Isapre) -->
      <ng-container *ngIf="shouldShowDeclaracionAccidente()">
        <div class="row w-100">
          <div class="col-xl-12 col-lg-12 col-md-12 p-2">
            <cas-textfield
              class="declaracion-accidente-textfield"
              [label]="'Descripción del accidente'"
              [value]="formInfoHosp.value.declaracionAccidente"
              [limit]="250"
              fullWidth
              (input)="onDeclaracionAccidenteChange($event, false)"
              (change)="onDeclaracionAccidenteChange($event, true)">
            </cas-textfield>
            <div class="declaracion-accidente-helper">
              {{ CONST_AUTOADM.PLACEHOLDER_DECLARACION_ACCIDENTE }}
            </div>
            <div *ngIf="isDeclaracionAccidenteError" class="error-text">
              {{ getDeclaracionAccidenteErrorText() }}
            </div>
            <div class="d-flex justify-content-end mt-2">
              <cas-button
                [text]="CONST_AUTOADM.BTN_GUARDAR_DECLARACION"
                variant="outline1" size="small"
                [attr.disabled]="isDeclaracionAccidenteListo() && !guardandoDeclaracion ? null : true"
                [disabled]="!isDeclaracionAccidenteListo() || guardandoDeclaracion"
                (click)="guardarDeclaracionAccidente()">
              </cas-button>
            </div>
          </div>
        </div>

        <div class="row w-100">
          <div class="col-xl-12 col-lg-12 col-md-12 p-2">
            <div class="cardCheck declaracion-accidente-download-card row mb-0 bg-white">
              <div class="col-12 checkin-card p-3">
                <div class="declaracion-accidente-card-body">
                  <div class="doc-icon-box" aria-hidden="true">
                    <cas-icon name="flat-paper" size="24"></cas-icon>
                  </div>
                  <div class="doc-card-content">
                    <div class="doc-card-eyebrow">Declaración de accidente</div>
                    <span class="declaracion-accidente-badge" [ngClass]="getDeclaracionAccidenteBadge().clase">
                      {{ getDeclaracionAccidenteBadge().texto }}
                    </span>
                    <div class="doc-card-title">Declaración de accidente</div>
                    <div class="doc-card-hint">{{ CONST_AUTOADM.MSJE_DECLARACION_ACCIDENTE_CARD }}</div>
                  </div>
                  <div class="doc-card-actions">
                    <cas-button
                      text="Descargar"
                      variant="outline1" size="small"
                      iconName="flat-download" iconSize="16"
                      loading="{{ loadingDescargaDeclaracion }}"
                      [disabled]="loadingDescargaDeclaracion"
                      (click)="onDescargarDeclaracionCard()">
                    </cas-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </ng-container>
      <!-- Fin. Declaración de accidente -->


      <!-- Inicio. Sucursal hospitalización / procedimiento cirugía  -->
      <!-- <div class="row w-100" *ngIf="(selectedMotivo === 'Parto' || selectedMotivo === 'Cirugía') && preSetPabellon"> -->

        <!-- Inicio. Sucursal hospitaliación -->
        <!-- <div class="col-xl-6 col-lg-6 col-md-12 p-2">
          <cas-select class="" formControlName="sucursalHospitalizacion"
              [label]="labelSucursal" [data]="listaSucursales"
              value="{{this.formInfoHosp.value.sucursalHospitalizacion}}"
              (change)="changeSelect($event, 'sucursalHospitalizacion')" fullWidth disabled>
          </cas-select>
        </div> -->
        <!-- Fin. Sucursal hospitaliación -->
 <!-- Inicio. Motivo de hospitalización -->
 <div class="row w-100">
        <div class="col-xl-6 col-lg-6 col-md-12 p-2">
          <mat-form-field class="custom-select-material w-100" floatLabel="always"
            [ngClass]="{'estilo-gris': ((selectedMotivo === 'Parto' || selectedMotivo === 'Cirugía') && preSetPabellon) || sinPabellon}"
            style="padding-left:12px !important; border: 1px solid #bcc2c6; border-radius: 9px; height: 56px; overflow: hidden;">
            <mat-label
              [ngClass]="{'estilo-gris': ((selectedMotivo === 'Parto' || selectedMotivo === 'Cirugía') && preSetPabellon) || sinPabellon}">Sucursal de hospitalización</mat-label>
            <mat-select id="idsucursal1" formControlName="sucursalHospitalizacion"
              [disabled]="((selectedMotivo === 'Parto' || selectedMotivo === 'Cirugía') && preSetPabellon) || sinPabellon"
              (selectionChange)="changeSelect($event, 'sucursalHospitalizacion')"><!--  -->
              <mat-option *ngFor="let sucursal of listaSucursales" [value]="sucursal"
                [selected]="formInfoHosp.value.sucursalHospitalizacion">
                {{ nombreSucursalDisplay(sucursal) }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div *ngIf="isSucursalError" class="error-text">
            Recuerda Ingresar la Sucursal.
          </div>
        </div>
<!-- Inicio. Motivo de hospitalización -->
        <!-- Inicio. Procedimiento cirugía -->
        <div *ngIf="(selectedMotivo === 'Parto' || selectedMotivo === 'Cirugía') && preSetPabellon" class="col-xl-6 col-lg-6 col-md-12 p-2">
          <cas-input  class=""
            formControlName="procedimientoCirugia"
            label="{{labelProcedimiento}}" value="{{this.formInfoHosp.value.procedimientoCirugia}}"
            (change)="changeSelect($event, 'procedimientoCirugia')"
            [placeholder]="labelProcedimiento" fullWidth [attr.disabled]="preSetPabellonStr">
          </cas-input>
        </div>
        <!-- Fin. Procedimiento cirugía -->

      </div>
      <!-- Inicio. Sucursal hospitalización / procedimiento cirugía  -->


      <!-- Inicio. Medico tratante / fecha de ingreso -->
      <div class="row w-100">

        <!-- Inicio. Médico tratante -->
        <div class="col-xl-6 col-lg-6 col-md-6 p-2">

          <mat-form-field class="w-100" appearance="fill" floatLabel="always" 
              [ngClass]="{'estilo-gris': (selectedMotivo === 'Parto' || selectedMotivo === 'Cirugía') && preSetPabellon}"
              style="padding-top: 18px !important; padding-left:12px !important; border: 1px solid #bcc2c6; border-radius: 9px; height: 56px; overflow: hidden;">
            
            <mat-label [ngClass]="{'estilo-gris': (selectedMotivo === 'Parto' || selectedMotivo === 'Cirugía') && preSetPabellon}">Médico tratante</mat-label>
            
            <input type="text" matInput [formControl]="medicoControl" [matAutocomplete]="auto" [disabled]="(selectedMotivo === 'Parto' || selectedMotivo === 'Cirugía') && preSetPabellon">
            
            <mat-autocomplete #auto="matAutocomplete"  [disabled]="(selectedMotivo === 'Parto' || selectedMotivo === 'Cirugía') && preSetPabellon"
                (keydown)="(selectedMotivo === 'Parto' || selectedMotivo === 'Cirugía') && preSetPabellon ? $event.preventDefault() : null"
                [displayWith]="displayMedico" (optionSelected)="onMedicoSelected($event.option.value)" (click)="this.indCargaMedico = false;">
              <mat-option *ngFor="let medico of filteredMedicos | async" [value]="medico">
                {{medico?.cv?.informacionPersonal?.primerNombre | titlecase }}&nbsp;
                {{medico?.cv?.informacionPersonal?.segundoNombre | titlecase }}&nbsp;
                {{medico?.cv?.informacionPersonal?.apellidoPaterno | titlecase }}&nbsp;
                {{medico?.cv?.informacionPersonal?.apellidoMaterno | titlecase }}
              </mat-option>
            </mat-autocomplete>
            
            <mat-progress-bar mode="indeterminate" *ngIf="indCargaMedico && !((selectedMotivo === 'Parto' || selectedMotivo === 'Cirugía') && preSetPabellon)" style="width: 90%;"></mat-progress-bar>
          </mat-form-field>

          <div *ngIf="isMedicoError && !noResultsFound && this.medicoControl.enabled" class="error-text">
            Recuerda buscar y seleccionar un médico.
          </div>
          <div *ngIf="noResultsFound && this.medicoControl.enabled" class="error-text">
            No se encontró Médico.
          </div>
        </div>

        <!-- <div class="col-xl-6 col-lg-6 col-md-6 p-2" *ngIf="(selectedMotivo === 'Parto' || selectedMotivo === 'Cirugía') && preSetPabellon">
          <cas-input class=""
            formControlName="medicoTratanteNombre" fullWidth
            label="Medico tratante" value="{{this.formInfoHosp.value.medicoTratanteNombre}}"
            [attr.disabled]="preSetPabellonStr">
          </cas-input>
        </div> -->
        <!-- Fin. Médico tratante -->


        <!-- Inicio. Fecha de ingreso -->
        <div class="col-xl-6 col-lg-6 col-md-6 p-2" *ngIf="(selectedMotivo !== 'Parto' && selectedMotivo !== 'Cirugía') || ((selectedMotivo === 'Parto'|| selectedMotivo === 'Cirugía') && !preSetPabellon)">

          <mat-form-field class="w-100" appearance="fill" floatLabel="always" style="border: 1px solid #bcc2c6; height: 56px; border-radius: 9px; padding-top: 12px !important;">
            <mat-label style="margin-left: 12px !important;">Fecha de ingreso</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="fechaIngreso" [(ngModel)]="formInfoHosp.value.fechaIngreso" style="margin-left: 14px;" (dateInput)="onDateInput($event)" onkeydown="return false">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <div *ngIf="formInfoHosp.get('fechaIngreso').errors?.invalidDate || isFechaIngresoError" class="error-text">
            Formato de fecha incorrecto. Usa dd-mm-aaaa.
          </div>
        </div>

      </div>
      <!-- Inicio. Medico tratante / fecha de ingreso -->


      <div class="row w-100">

        <!-- Inicio. Fecha de pabellon -->
        <div class="col-xl-6 col-lg-6 col-md-6 p-2" *ngIf="(selectedMotivo === 'Parto' || selectedMotivo === 'Cirugía') && preSetPabellon">

          <mat-form-field class="w-100" appearance="fill" floatLabel="always"
                          style="border: 1px solid #bcc2c6; height: 56px; border-radius: 9px; padding-top: 14px !important;"
                          [ngClass]="{'estilo-gris': preSetPabellonStr}">
            <mat-label style="margin-left: 12px !important;" [ngClass]="{'estilo-gris': preSetPabellonStr}">Fecha de Pabell&oacute;n</mat-label>
            <input matInput [matDatepicker]="pickerPabellon" formControlName="fechaPabellon"
                   [(ngModel)]="formInfoHosp.value.fechaPabellon"
                   style="margin-left: 14px; color: rgb(54, 72, 85)"
                   (dateInput)="onDateInput($event)"
                   onkeydown="return false"
                   [disabled]="preSetPabellonStr">
            <mat-datepicker-toggle matSuffix [for]="pickerPabellon" [ngClass]="{'no-pointer-events': preSetPabellonStr}"></mat-datepicker-toggle>
            <mat-datepicker #pickerPabellon></mat-datepicker>
          </mat-form-field>
          <div *ngIf="formInfoHosp.get('fechaPabellon').errors?.invalidDate || isFechaIngresoError" class="error-text">
            Formato de fecha incorrecto. Usa dd-mm-aaaa.
          </div>

        </div>
        <!-- Fin. Fecha de pabellon -->


        <!-- Inicio. Hora de pabellon -->
        <div class="col-xl-6 col-lg-6 col-md-6 p-2" *ngIf="(selectedMotivo === 'Parto' || selectedMotivo === 'Cirugía') && preSetPabellon">
          <cas-input
          style="font-size: 16px; text-align: center;"
          class="" icon="flat-clock" iconSize="20" alignment="trailing"
          label="{{labelHoraPab}}" formControl="horaPabellon"
          value="{{this.formInfoHosp.value.horaPabellon}}"
          [(ngModel)]="hora"
          (input)="formatoHora($event)"
          (change)="changeSelect($event, 'horaPabellon')" [attr.disabled]="preSetPabellonStr" fullWidth>
          </cas-input>
        </div>
        <!-- Fin. Hora de pabellon -->

      </div>


      <!-- Inicio. Mensaje informativo -->
      <div class="row w-100" *ngIf="(selectedMotivo === 'Parto' || selectedMotivo === 'Cirugía') && preSetPabellon">
        <div class="col-xl-12 col-lg-12 col-md-12 p-2">
          <cas-alert class="" style="width: 100%!important;" size="small"
          text="{{mjePabellon}}">
        </cas-alert>
        </div>
      </div>
      <!-- Fin. Mensaje informativo -->


      <!-- Inicio. Botonera -->
      <div class="botonera d-flex flex-wrap gap-2 w-100 my-4">
        <cas-button text="Volver" variant="text1" (click)="volver()" class="pe-1"></cas-button>
        <cas-button
          text="Continuar"
          variant="primary1"
          [attr.disabled]="!isContinuarBloqueadoPorDeclaracion() ? null : true"
          [disabled]="isContinuarBloqueadoPorDeclaracion()"
          (click)="submitAntecedentes()">
        </cas-button>
      </div>
      <!-- Fin. Botonera -->

    </form>
    <!-- Fin. Form -->

    <app-pdf-preview-modal
      [open]="pdfPreviewOpen"
      [title]="pdfPreviewTitle"
      [fileName]="pdfPreviewFileName"
      [src]="pdfPreviewUrl"
      (closed)="cerrarPdfPreview()">
    </app-pdf-preview-modal>

  </div>
</div>
